import './S_ErrorFeedback.scss';
import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import { S_Feedback } from '../S_Feedback';

interface IProps {
  className?: string;
  children?: ReactNode;
}

export const S_ErrorFeedback = ({ children, className }: IProps): ReactElement => (
  <S_Feedback className={classNames('error-feedback', className)}>{children}</S_Feedback>
);
